<template>
  <div class="page-wrapper">
        <main-navigation></main-navigation>

    <main class="container py-4">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="fw-bold page-title"><i class="bi bi-cash-stack"></i> Payments</h4>

        <router-link to="/receive/payments" class="btn btn-primary">
          + Receive Payment
        </router-link>
      </div>

      <!-- Card -->

      <!-- {{ payments }} -->
      <div class="dash-card">

        <!-- Loading -->
        <div v-if="loading" class="dash-state">
          <div class="dash-spinner"></div>
          <p>Loading payments...</p>
        </div>

        <!-- Empty -->
        <div v-else-if="!payments.length" class="dash-state">
          <i class="bi bi-cash-stack" style="font-size: 2rem;"></i>
          <p>No payments found</p>
        </div>

        <!-- Table -->
        <div v-else class="dash-table-wrap">
          <table class="dash-table">

            <thead>
              <tr>
                <th>#</th>
                <th>Transaction ID</th>
                <th>Tenant</th>
                <th>Phone</th>
                <th>Amount</th>
                <th>Paid by</th>
                <th>Shortcode</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(p, index) in payments" :key="p.TransID || index">

                <td>{{ index + 1 }}</td>

                <td class="fw-semibold">
                  {{ p.TransID || "-" }}
                </td>

                <!-- Tenant link -->
                <td>
                  <router-link
                    v-if="p.tenant_id"
                    :to="`/tenant/${p.tenant_id}`"
                    class="text-decoration-none fw-semibold text-primary"
                  >
                    {{ p.Tenant?.tenant_name || "Unknown" }}
                  </router-link>
                  <span v-else>{{ p.tenant_name || "Unknown" }}</span>
                </td>

                <td>{{  p.Tenant?.tenant_phone || "-" }}</td>

                <td class="fw-bold text-success">
                  KES {{ formatAmount(p.TransAmount) }}
                </td>

                <td>{{ p.FirstName || "-" }}</td>

                <td>{{ p.BusinessShortCode || "-" }}</td>

                <td>{{ formatDate(p.payment_date) }}</td>

                <td>
                  <span
                    class="dash-badge"
                    :class="p.processed ? 'dash-badge--success' : 'dash-badge--warning'"
                  >
                    {{ p.processed ? "Processed" : "Pending" }}
                  </span>
                </td>

              </tr>
            </tbody>

          </table>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
  name: "PaymentsList",

  data() {
    return {
      payments: [],
      loading: false,
    };
  },

  async mounted() {
    this.fetchPayments();
  },

  methods: {
    async fetchPayments() {
      this.loading = true;

      try {
        const res = await apiFetch("/get/payments");

        console.log("🔥 FULL API RESPONSE:", res);

        // ✅ HANDLE ALL POSSIBLE RESPONSE STRUCTURES
        if (Array.isArray(res)) {
          this.payments = res;
        } else if (res?.data && Array.isArray(res.data)) {
          this.payments = res.data;
        } else if (res?.payments && Array.isArray(res.payments)) {
          this.payments = res.payments;
        } else {
          console.warn("⚠️ Unexpected response format:", res);
          this.payments = [];
        }

      } catch (error) {
        console.error("❌ Failed to fetch payments:", error);
        this.payments = [];
      } finally {
        this.loading = false;
      }
    },

    formatAmount(amount) {
      return Number(amount || 0).toLocaleString();
    },

    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleString();
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  background: var(--dash-bg);
  min-height: 100vh;
}

/* Page title — matches the shared heading treatment in design.css */
.page-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--dash-fs-h1);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--dash-ink);
}

.page-title i {
  font-size: 1.05em;
  color: var(--dash-primary);
}
</style>